import { render, staticRenderFns } from "./EditProjectDetail.vue?vue&type=template&id=bd88374e&scoped=true"
import script from "./EditProjectDetail.vue?vue&type=script&lang=js"
export * from "./EditProjectDetail.vue?vue&type=script&lang=js"
import style0 from "./EditProjectDetail.vue?vue&type=style&index=0&id=bd88374e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd88374e",
  null
  
)

export default component.exports